<template>
  <div class="table-content" :class="{ 'flex':autoHeight, 'flex-column':autoHeight, 'flex-item':autoHeight,}">
    <el-card shadow="never" :body-style="{ padding: '10px', minHeight: '10vh' }" class="table-container" :class="{ 'flex':autoHeight, 'flex-column':autoHeight, 'flex-item':autoHeight,}">
      <div><slot name="header" /></div>
      <div :class="{'flex-item':autoHeight}" :style="{maxHeight: autoHeight?'calc(100% - 60px)':'auto'}">
        <el-table
          ref="iTable"
          v-loading="loading"
          :data="data"
          :empty-text="emptyText"
          stripe
          :height="autoHeight?'100%':''"
          v-bind="$attrs"
          v-on="$listeners"
        >
          <el-table-column v-if="checkbox" type="selection" />
          <el-table-column v-if="hasNO" type="index" label="序号" />
          <slot />
        </el-table>
      </div>
      

      <div class="table-pagination" v-if="isShowPagination">
        <el-pagination
          ref="pagination"
          :current-page.sync="page"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          background
          @current-change="searchPage"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import { initData } from '@/api/data'
export default {
  name: 'ITable',
  props: {
    // 序号 默认无
    hasNO: {
      type: Boolean,
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    },
    searchForm: {
      type: Object,
      default() {
        return {}
      }
    },
    dataProp: {
      type: String,
      default: 'data.list'
    },
    pageProp: {
      type: String,
      default: 'data.pagination.total'
    },
    index: {
      type: Boolean,
      default: true
    },
    method: {
      type: String,
      default: 'get'
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    autoSend: {
      type: Boolean,
      default: true
    },
    defaultSort: {
      type: Object,
      default: null
    },
    isShowPagination: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Object,
      default() {
        return {
          pageSize: 10, // 每页展示行数
          page: 1, // 当前页码
          total: 0 // 总行数
        }
      }
    },
    pageSizeList:{
      type: Array,
      default: []
    }
  },
  data() {
    return {
      data: [],
      pageSize: 10, // 每页展示行数
      page: 1, // 当前页码
      total: 0, // 总行数
      // 表格 Loading 属性
      loading: true,
      emptyText: '暂无数据',
      pageSizes:[10, 15, 20, 50, 100, 200]
    }
  },
  watch: {
    "data":{
      handler(){
        this.$nextTick(()=> {
          this.$refs.iTable.doLayout();
        });
      },
      deep: true
    }
  },
  created() {
    if(this.pageSizeList && this.pageSizeList.length){
      this.pageSizes = this.pageSizeList;
    }
    this.pageSize = this.pagination.pageSize;
    this.page = this.pagination.page;
    this.total = this.pagination.total;
    
  },
  mounted() {
    if (this.autoSend) {
      this.$nextTick(() => {
        this.searchPage()
      })
    }
  },
  methods: {
    reload(){
      this.$refs.iTable.doLayout();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.searchPage()
    },
    searchPage() {
      const param = {
        currentPage: this.page,
        pageSize: this.pageSize
      }
      const newParam = Object.assign({}, this.searchForm)
      for (const key in newParam) {
        if (Object.prototype.hasOwnProperty.call(newParam, key)) {
          if (typeof newParam[key] === 'string') {
            if (newParam[key] === '') {
              newParam[key] = null
            } else {
              newParam[key] = newParam[key].trim()
            }
          }
        }
      }

      const params = Object.assign(param, newParam)
      this.page = params.currentPage
      this.pageSize = params.pageSize
      // this.data = []
      this.loading = true
      this.emptyText = '加载中,请稍等......'
      initData(this.url, params, this.method).then(response => {
        this.loading = false
        if(response.data && response.data.list){
          if(this.defaultSort){
            if(this.defaultSort.type == 'desc'){
              response.data.list.sort((a, b) => parseFloat(b[this.defaultSort.prop]) - parseFloat(a[this.defaultSort.prop]));
            }
            if(this.defaultSort.type == 'asc'){
              response.data.list.sort((a, b) => parseFloat(a[this.defaultSort.prop]) - parseFloat(b[this.defaultSort.prop]));
            }
          }
        }
        
        this.data = response.data.list || []
        this.total = response.data.pagination.total
        this.emptyText = '暂无数据'
        this.$emit('afterSearch', response.data)
        this.$emit('backPagination', {
          pageSize: this.pageSize, // 每页展示行数
          page: this.page, // 当前页码
          total: this.total // 总行数
        })
      }).catch(() => {
        this.emptyText = '暂无数据'
      })
    },
    indexMethod(index) {
      return index + this.pageSize * (this.page - 1) + 1
    },
    // 对外提供查询列表操作
    // noResetPage为true时不重置page
    search(noResetPage) {
      this.$nextTick(() => {
        if(!noResetPage){
          this.page = 1
        }
        this.searchPage()
      })
    },
    resetCheck(data){
      data.forEach(element => {
        this.$refs.iTable.toggleRowSelection(element, false);
      });
      
    },
    clear() {
      this.data = []
      this.total = 0
      this.page = 1
    }
  }
}
</script>
<style lang="scss">
.table-content{
  overflow: hidden;
}
.has-gutter {
  .cell {
    font-size: 12px !important;
  }
}

.el-table th.el-table__cell {
  background-color: #f1f1f1;
}

.el-table td.el-table__cell {
  padding: 14px 0;
}

.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: rgba(202, 215, 229, .8);
}

.table-pagination {
  margin-top: 15px;
  padding-bottom: 5px;
}
</style>
